<template>
  <TableStatic :loading="loading" :rows="rows" :columns="columns" :line-numbers="lineNumbers">
    <template slot="table-row" slot-scope="props">
      <strong v-if="props.column.field === 'amount'">
        {{ props.row.amount | currency }}
      </strong>
      <p v-else-if="props.column.field === 'interestRate'" class="whitespace-nowrap">
        {{ `${props.row.interestRate}%` }}
      </p>
      <template v-else-if="props.column.field === 'rateAmount'">
        {{ props.row.rateAmount | currency }}
      </template>
      <template v-else-if="props.column.field === 'increaseRateAmount'">
        {{ props.row.increaseRateAmount | currency }}
      </template>
      <template v-else-if="props.column.field === 'payAmount'">
        {{ props.row.payAmount | currency }}
      </template>
      <template v-else-if="props.column.field === 'paidAmount'">
        {{ props.row.paidAmount | currency }}
      </template>
      <p v-else-if="props.column.field === 'startDate'" class="whitespace-nowrap">
        {{ props.row.startDate }}
      </p>
      <p v-else-if="props.column.field === 'endDate'" class="whitespace-nowrap">
        {{ props.row.endDate }}
      </p>
      <p v-else-if="props.column.field === 'paidDate'" class="whitespace-nowrap">
        {{ props.row.paidDate }}
      </p>
      <div v-else-if="props.column.field === 'status'" class="whitespace-nowrap">
        <div :class="['status', `is-${getStatus(props.row.status)}`]">
          {{ $t(`status.${getStatus(props.row.status)}`) }}
        </div>
      </div>
      <p v-else-if="props.column.field === 'action'" class="flex justify-end items-center">
        <router-link
          :to="{ name: 'LoanDetails', params: { loanId: props.row.id } }"
          class="flex items-center"
        >
          <EyeIcon class="w-4 h-4" />
        </router-link>
      </p>
    </template>
  </TableStatic>
</template>

<script>
import TableStatic from '@/components/ui/table/TableStatic';
import tableMixin from '@/mixins/tableMixin';
import humps from 'humps';

export default {
  mixins: [tableMixin],
  components: {
    TableStatic,
  },
  methods: {
    getStatus(status) {
      return status ? humps.camelize(status).toLowerCase() : '';
    },
  },
};
</script>
